module.exports = __webpack_public_path__ + "static/robodog-b6a3b474a964b76358f72ee5afeea8bc.png";